import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const REASONS = ["Sahte / dolandırıcılık", "Yanlış bilgi", "Uygunsuz içerik", "Spam", "Diğer"];

export default function ReportButton({ targetType, targetId, label = "Bildir" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [details, setDetails] = useState("");
  const submit = async () => {
    try {
      await api.post("/reports", { target_type: targetType, target_id: targetId, reason, details });
      toast.success("Bildiriminiz alındı");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!user) return null;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid={`report-${targetType}-${targetId}`} className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-red-400">
          <Flag className="h-3 w-3" /> {label}
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>İçeriği bildir</DialogTitle></DialogHeader>
        <Select value={reason} onValueChange={setReason}>
          <SelectTrigger data-testid="report-reason-select" aria-label="Bildirim nedeni"><SelectValue /></SelectTrigger>
          <SelectContent>{REASONS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
        </Select>
        <Textarea data-testid="report-details-input" aria-label="Bildirim açıklaması" placeholder="Açıklama (isteğe bağlı)" value={details} onChange={(e) => setDetails(e.target.value)} />
        <Button data-testid="report-submit-button" onClick={submit} className="bg-red-600 hover:bg-red-500">Gönder</Button>
      </DialogContent>
    </Dialog>
  );
}
